__turbopack_context__.v({
  "accordionSlideOverwrite": "authFormContainer-module-scss-module__VjCI1a__accordionSlideOverwrite",
  "authFormContainer": "authFormContainer-module-scss-module__VjCI1a__authFormContainer",
  "fadeIn": "authFormContainer-module-scss-module__VjCI1a__fadeIn",
  "fadeOut": "authFormContainer-module-scss-module__VjCI1a__fadeOut",
  "left": "authFormContainer-module-scss-module__VjCI1a__left",
  "notification": "authFormContainer-module-scss-module__VjCI1a__notification",
  "right": "authFormContainer-module-scss-module__VjCI1a__right",
  "scaleIn": "authFormContainer-module-scss-module__VjCI1a__scaleIn",
  "scaleOut": "authFormContainer-module-scss-module__VjCI1a__scaleOut",
  "wrapper": "authFormContainer-module-scss-module__VjCI1a__wrapper",
  "zoomIn": "authFormContainer-module-scss-module__VjCI1a__zoomIn",
  "zoomOut": "authFormContainer-module-scss-module__VjCI1a__zoomOut",
});
